const BoxSelector = ({ totalBoxes = 4, value, onChange, label }) => {
  const options = Array.from({ length: totalBoxes }, (_, i) => i + 1);

  return (
    <div>
      {label && (
        <label className="block text-sm font-medium text-text-secondary mb-2 ml-1">
          {label}
        </label>
      )}
      <div className="flex gap-2">
        {options.map((option) => (
          <button
            key={option}
            type="button"
            onClick={() => onChange(option)}
            className={` size-8 box-border  flex items-center justify-center border rounded-lg text-sm font-medium transition-all
              ${
                value === option
                  ? "bg-primary/30 text-primary-navy border-primary shadow-md"
                  : "bg-white text-text-primary border-border hover:bg-primary/10"
              }`}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
};

export default BoxSelector;
